import React, { useState, useEffect } from "react";
import ModalExecution from "./ModalExecutionNew";
// import ModalExecutionNew from "./ModalExecutionNew";
import ModalStatistic from "./ModalStatistic";
import ModalPillars from "./ModalPillars";
import ModalLayers from "./ModalLayers";
import { useMap } from "react-leaflet";
// import ModalKanban from "./ModalKanban";
import ModalSearch from "./ModalSearch";
import ModalTpFilter from "./ModalTpFilter";
import ModalAccountingSheetTable from "./ModalAccountingSheetTable";
import ModalConclusions from "./ModalConclusions";
import ModalRules from "./ModalRules";
import ModalBindingErrors from "./ModalBindingErrors";
import { useSelector } from "react-redux";
import ModalTasks from "./ModalTasks";

const Modal = () => {
    console.log('Modal')
    const map = useMap()
    const modal = useSelector(
        (state) => state.helper.modal
    );
    
    useEffect(() => {
        if (!modal) {
            map.fire('modal:close')
        } else {
            map.fire('modal:open', { modalType: modal.modalType })
        }
    }, [modal, map])
    
    if (!modal) {
        return null
    }
    switch (modal.modalType) {
        case 'statistic':
            return <ModalStatistic buttonPosition={modal.modalProps?.buttonPosition} />
        case 'execution':
            console.log(modal)
            return <ModalExecution ids={modal.modalProps.ids} mode={modal.modalProps.mode} mounted={modal.modalProps.mounted} />
        case 'pillar':
            return <ModalPillars mark={modal.modalProps} />
        case 'tasks':
            return <ModalTasks />
        case 'layers':
            return <ModalLayers buttonPosition={modal.modalProps?.buttonPosition} />
        case 'search':
            return <ModalSearch buttonPosition={modal.modalProps?.buttonPosition} />
        case 'tpfilter':
            return <ModalTpFilter buttonPosition={modal.modalProps?.buttonPosition} />
        case 'accountingSheetTable':
            return <ModalAccountingSheetTable buttonPosition={modal.modalProps?.buttonPosition} />
        case 'conclusionsTable':
            return <ModalConclusions />
        case 'rulesTable':
            return <ModalRules />
        case 'bindingErrors':
            return <ModalBindingErrors buttonPosition={modal.modalProps?.buttonPosition} />
    }
    // if (modalType === 'statistic') return <ModalStatistic buttonPosition={modalProps?.buttonPosition} />
    // if (modalType === 'inventory') return <ModalInventory ids={modalProps.ids} verified={modalProps.verified} />
    // if (modalType === 'pillar') return <ModalPillars mark={modalProps} />
    // if (modalType === 'tasks') return <ModalTasks />
    // if (modalType === 'layers') return <ModalLayers buttonPosition={modalProps?.buttonPosition} />
    // if (modalType === 'search') return <ModalSearch buttonPosition={modalProps?.buttonPosition} />  
    // if (modalType === 'tpfilter') return <ModalTpFilter buttonPosition={modalProps?.buttonPosition} />
    // if (modalType === 'accountingSheetTable') return <ModalAccountingSheetTable buttonPosition={modalProps?.buttonPosition} />
}




export default Modal